export const DEFAULT_TEACHER_GRADE = {
  CURRICULUM: '6th Grade',
  STANDALONE: 'THIRD'
};

export const DEMO_SECTION_BK_PREFIX = 'demo-section-';

export const DEMO_SECTION_NAME = 'Demo Class';
